export default {"src":"/_next/static/media/SpreaderIcon.ee9b6878.svg","height":78,"width":130};